import React, { memo, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'

function AdsPortal({ adsData }) {
  const [active, setActive] = useState({ a: false })
  useEffect(() => {
    setActive({ a: true })
  }, [adsData])

  if (active.a) {
    return adsData?.map((ad) => {
      const target = document.getElementById(ad.id)
      return (ad.show ?? true) && target ? (
        <React.Fragment key={ad?.id}>{createPortal(ad?.component, target, ad.id)} </React.Fragment>
      ) : null
    })
  } else return null
}

AdsPortal.propTypes = {
  adsData: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default memo(AdsPortal)
